import { PdsWidget } from '../../pds-widget';
import {PillSelectFilter} from '../../models/grid-widget/pill-select-filter';
import { pdsLogger } from '../../pds-logger';
let log = pdsLogger.prependLogger(pdsLogger.requiresLogger('gridWidget'), 'pds-gw-pill-select-filter.ts');

export class PdsGwPillSelectFilter extends PdsWidget {
  is = 'pds-gw-pill-select-filter';

  //Input
  filter: PillSelectFilter | null;

  properties = {
    filter: {
      value: null
    }
  };

  //Called when the user clicks on one of the pills.
  selectItem(event: Event): void {
    log('selectItem called.');

    let item = this.extractProperty(event, 'button', 'item');
    console.log(JSON.stringify(item, null, 2));
    if (item != null && this.filter != null) {
      this.filter.searchValue = item.value;
      this.redrawTrigger = !this.redrawTrigger;
      let event: Event = new Event('renderedElementValueChange', {bubbles: true});
      this.dispatchEvent(event);
    }
  }

  getIsPrimaryClass(item: {key: string, value: string}): 'pds-primary' | '' {
    return this.filter != null && item.value === this.filter.searchValue ? 'pds-primary' : '';
  }
}
